import {isRangeFilter, RANGE_FILTER_DELIMITER} from './rangeFilterUtils';

export const updateUrlParams = ({
  search,
  update,
}: {
  search?: string;
  update: Map<string, Array<string> | undefined>;
}): string | undefined => {
  const allParams = new URLSearchParams(search ?? '');
  const paramsUpdated = new URLSearchParams();

  const keysToUpdate = Array.from(update.keys());
  const keysToKeep = Array.from(allParams.keys()).filter(
    key => allParams.get(key) && !keysToUpdate.includes(key),
  );

  keysToKeep.forEach(key => {
    paramsUpdated.set(key, allParams.get(key)!.toString());
  });

  keysToUpdate.forEach(key => {
    const updateValue = update.get(key);

    if (updateValue?.length) {
      const valuesDelimiter = isRangeFilter(key) ? RANGE_FILTER_DELIMITER : ',';
      paramsUpdated.set(key, update.get(key)!.join(valuesDelimiter));
    } else {
      paramsUpdated.delete(key);
    }
  });

  return paramsUpdated.toString();
};
